export default {
  data() {
    return {
      status: this.$route.query.status,
      exchangePath: process.env.VUE_APP_EXCHANGE_ADDRESS,
    }
  },
}
